import {useState} from 'react'
import OrganizationWiseDashboardAllocationForm from './OrganizationWiseDashboardAllocationForm';
import OrganizationWiseDashboardAllocationList from './OrganizationWiseDashboardAllocationList';

const OrganizationWiseDashboardAllocation = () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);
    const [serviceId, setServiceId] = useState("none");
  
  return (
    <>
      {fromIsShown ? (
          <OrganizationWiseDashboardAllocationForm addForm={setFromIsShown} update={upData} sId={serviceId}/>
        ) : (
          <OrganizationWiseDashboardAllocationList addForm={setFromIsShown} update={setUpData} sId={setServiceId}/>
        )}
  
    </>
  )
}

export default OrganizationWiseDashboardAllocation